// Featured guides carry one schedule per length ("Florence 1 day" …
// "Florence 7 days") plus "Main", the one a guide opens on. In 192 of the
// 436 Featured guides (checked 2026-10-26) Main was shorter than the longest
// schedule, or missing, so "Florence 1-7 days" opened on 4 days. The Admin
// Dashboard uses these to list and fix them: Main becomes a copy of the
// longest schedule. Works on the stored JSON (guide_data.schedule.events).

const scheduleOf = (event) => (typeof event.Itinerary === "string" && event.Itinerary !== "" ? event.Itinerary : "Main");

// { name: { days, events } } — days = distinct start dates.
export function scheduleSummary(events) {
  const out = {};
  for (const e of events || []) {
    const name = scheduleOf(e);
    if (!out[name]) out[name] = { days: new Set(), events: 0 };
    out[name].days.add(String(e.Start || "").slice(0, 10));
    out[name].events += 1;
  }
  for (const name of Object.keys(out)) out[name].days = out[name].days.size;
  return out;
}

// null when Main is fine, else { from, fromDays, mainDays } (mainDays 0 =
// no Main). Longest = most days, then most events.
export function planMainFix(events) {
  const summary = scheduleSummary(events);
  let from = null;
  for (const name of Object.keys(summary)) {
    if (name === "Main") continue;
    const s = summary[name];
    if (from == null || s.days > summary[from].days || (s.days === summary[from].days && s.events > summary[from].events)) from = name;
  }
  if (from == null) return null;
  const mainDays = summary.Main ? summary.Main.days : 0;
  if (mainDays >= summary[from].days) return null;
  return { from, fromDays: summary[from].days, mainDays };
}

const newId = () => String(Math.floor(Math.random() * 1000000000 + 1));
const newCommentKey = () => `${new Date().toISOString()}-${Math.random().toString(36).slice(2, 10)}`;

// Returns a new events array: the old Main events dropped, copies of the
// longest schedule's events added as Main (fresh ID and CommentKey, the same
// as Schedule.copySchedule). Other schedules are left exactly as they were.
export function applyMainFix(events, plan = planMainFix(events)) {
  if (!plan) return events;
  const kept = events.filter((e) => scheduleOf(e) !== "Main");
  const used = new Set(kept.map((e) => e.ID));
  const copies = kept
    .filter((e) => scheduleOf(e) === plan.from)
    .map((e) => {
      let id = newId();
      while (used.has(id)) id = newId();
      used.add(id);
      return { ...e, Itinerary: "Main", ID: id, CommentKey: newCommentKey() };
    });
  return kept.concat(copies);
}
